import axiosClient from './axiosClient';

export const recordCheckIn = (payload) =>
  axiosClient.post('/checkins', payload).then((r) => r.data?.data);

export const listCheckins = (search) =>
  axiosClient.get('/checkins', { params: { search } }).then((r) => r.data?.data ?? []);
